import { useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "../services/Api";
import { showToast } from "../utils";

interface RateModel {
  type: 'FIXED' | 'SPREAD' | 'CDI';
  value: number;
  active: boolean;
}

interface PostRateRequest {
  observation: string;
  idSeller: string;
  models: RateModel[];
}

export function useAnticipation(hasAntecipation: boolean = false) {
  const [antecipationModalState, setAntecipationModalState] = useState<boolean>(false)
  const [antecipationSwitchState, setAntecipationSwitchState] = useState<boolean>(hasAntecipation)
  const [titleMessage, setTitleMessage] = useState<string>("")
  const baseUrl = "/antecipation/rate"
  const { id } = useParams()

  function handleToggleSellerWithAnticipation(e?: boolean) {
    e ? setTitleMessage("Ativar") : setTitleMessage("Desativar")
    setAntecipationModalState(true)
    setAntecipationSwitchState(e as boolean)
  }

  async function setAntecipationState(antecipationState: boolean) {
    try {
      await api.patch(`/sellers/${id}/anticipation`, {
        active: antecipationState
      })

      showToast({
        type: "success",
        message: `Antecipação ${antecipationSwitchState ? "ativada" : "desativada"} com sucesso.`
      })

    } catch (error) {
      showToast({
        type: "error",
        message: "Falha ao selecionar o status de cliente com antecipação."
      })
    }
    setAntecipationModalState(false)
  }

  async function getAntecipationRate(id: string) {
    try {
      const response = await api.get(`${baseUrl}?idSeller=${id}`)
      return response?.data
    } catch (error) {
      showToast({
        type: "error",
        message: "Falha ao selecionar o status de cliente com antecipação."
      })
    }
  }

  async function postAntecipationRate(object: PostRateRequest) {
    try {
      const response = await api.post(baseUrl, object)
      return response.data
    } catch (error) {
      showToast({
        type: "error",
        message: "Falha ao selecionar o status de cliente com antecipação."
      })
    }
  }

  return {
    antecipationModalState,
    titleMessage,
    antecipationSwitchState,
    handleToggleSellerWithAnticipation,
    setAntecipationModalState,
    setAntecipationState,
    setAntecipationSwitchState,
    getAntecipationRate,
    postAntecipationRate
  }
}